export const statusesMap = new Map([
	['appointed', 'Забронировано'],
	['visit_started', 'Гости пришли'],
	['visit_ended', 'Гости ушли'],
	['cancelled', 'Отменено'],
	['in_progress', 'В процессе'],
	['visit_missed', 'Гости не пришли'],
	['waiting_list', 'Лист ожидания'],
]);

export const depositMap = new Map([
  ['created' , 'Создан'],
  ['processed' , 'В обработке'],
  ['rejected' , 'Отклонен'],
  ['done' , 'Оплачено'],
  ['canceled' , 'Отменено'],
])
